<template>
  <div class="wrap">
    <transition name="chat">
      <ChatIcon v-if="shown" class="chat-icon" :src="src" />
    </transition>
    <div :class="balloonWrapClasses">
      <Loader :dark="dark" v-if="loading" />
      <transition name="chat">
        <p v-if="!loading" class="text-balloon">
          <slot />
          <span class="pick"></span>
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
import Loader from './Loader'
import ChatIcon from './ChatIcon'

export default {
  name: 'TextBalloon',
  data () {
    return {
      shown: false,
      loading: true
    }
  },
  methods: {
    isLoaded () {
      this.shown = true
      setTimeout(() => {
        this.loading = false
      }, 1500)
    }
  },
  mounted () {
    this.isLoaded()
  },
  computed: {
    balloonWrapClasses () {
      return {
        'balloon-wrap': true,
        'dark': this.dark
      }
    }
  },
  components: {
    Loader,
    ChatIcon
  },
  props: {
    src: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-enter-active,
.chat-leave-active {
  transition: all 400ms;
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.chat-enter,
.chat-leave-to {
  opacity: 0;
  transform: translateY(5px) scale(0.6);
}

.balloon-wrap {
  max-width: calc(100% - 120px);

  @media (max-width: 767px) {
    width: calc(100% - 120px);
  }
}

.wrap {
  @extend %clearfix;

  clear: both;

  &:nth-child(odd) {
    .chat-icon,
    .balloon-wrap {
      float: right;
    }

    .balloon-wrap {
      margin-right: 40px;
    }

    .pick {
      right: -15px;

      &::before {
        left: 5px;
      }
    }
  }

  &:nth-child(even) {
    .chat-icon,
    .balloon-wrap {
      float: left;
    }

    .balloon-wrap {
      margin-left: 40px;
    }

    .pick {
      left: -15px;

      &::before {
        right: 5px;
      }
    }
  }
}

.wrap + .wrap {
  margin-top: 30px;
}

.text-balloon {
  background-color: $c-red;
  color: white;
  display: inline-block;
  position: relative;
  padding: 10px 12px;
  border-top: 5px solid $c-red;
  border-bottom: 5px solid $c-red;

  &::before,
  &::after {
    content: '';
    top: 0;
    width: 5px;
    height: 100%;
    position: absolute;
    background-color: $c-red;
  }

  &::before {
    left: -5px;
  }

  &::after {
    right: -5px;
  }
}

.pick {
  position: absolute;
  bottom: -5px;
  width: 15px;
  background-color: $c-red;
  height: 5px;

  &::before {
    content: '';
    background-color: $c-red;
    position: absolute;
    top: -5px;
    width: 5px;
    height: 5px;
  }
}

.dark {
  .text-balloon {
    border-top-color: $c-dark;
    border-bottom-color: $c-dark;

    &,
    &::before,
    &::after {
      background-color: $c-dark;
    }
  }

  .pick {
    &,
    &::before,
    &::after {
      background-color: $c-dark;
    }
  }
}
</style>
